module.exports = __webpack_public_path__ + "assets/img/mecha-btn-664e2d41.png";